import type { ContentfulBlock, ContentfulBlockWithForm, ContentfulSpacing } from '@/lib/contentful-api'

export type HalfHalfContentFields = ContentfulBlock['fields'] | ContentfulBlockWithForm['fields']

export function isBlockWithFormFields(fields: HalfHalfContentFields | undefined): fields is ContentfulBlockWithForm['fields'] {
  return fields !== undefined && 'form' in fields
}

export interface HalfHalfBlockFields extends ContentfulSpacing {
  name?: string
  backgroundColor?: 'White' | 'Grey' | 'White Inside' | 'Grey Inside'
  layout?: 'Left Image' | 'Right Image'
  mobileLayout?: 'Image Top' | 'Text Top'
  content?: ContentfulBlock | ContentfulBlockWithForm
  contained?: boolean
}

export type HalfHalfBlockType = {
  sys?: {
    contentType: {
      sys: {
        id: 'halfHalf'
      }
    }
  }
  isFirst?: boolean
  fields?: HalfHalfBlockFields
} & HalfHalfBlockFields
